import { j as jsxRuntimeExports } from './../../../../../ext/react/jsx-runtime.js';
import { Base } from '../../../Internal/Base/Base.js';

const pathStrings = {
    16: [
        'M14.006 0C15.107 0 16 .9 16 1.992v8.012c0 .55-.313 1.309-.706 1.702l-3.588 3.588c-.39.39-1.15.706-1.702.706H1.992C.892 16 0 15.105 0 14.006V1.994C0 .893.895 0 1.994 0h12.012zM14 2H2v12h7v-3c0-1.105.892-2 2-2h2.999L14 2zm-.829 9H11v2.171L13.171 11zM7 8v2H4V8h3zm5-4v2H4V4h8z',
    ],
};
const IconNotes = ({ size, className, ...rest }) => {
    const paths = pathStrings[size].map((d, i) => (jsxRuntimeExports.jsx("path", { d: d, fillRule: "evenodd" }, String(i))));
    return (jsxRuntimeExports.jsx(Base, { as: "svg", height: size, width: size, viewBox: `0 0 ${size} ${size}`, className: className, xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", preserveAspectRatio: "xMidYMid meet", fill: "currentColor", ...rest, children: paths }));
};
IconNotes.displayName = 'IconNotes';

export { IconNotes };
//# sourceMappingURL=IconNotes.js.map
